import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { DropDown } from "./myDropDown";
import { AllocatedDropdown } from "./allocatedDropdown";
import { checkJobType, timeSince } from "../../utils/EllowUtils";
import ButtonDefault from "../button";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import PopOver from "../popover";
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import { useState } from "react";
import { getPositionsDetails } from './services';
import { Icon } from "@iconify/react";


const PositionTable = (props: any) => {

  const navigate = useNavigate()
  const [draftKey, setDraftKey] = useState<any>(props.draftKey)
  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "desc" },
  ];

  const [sort, setSort] = useState(initialSort);
  const viewButton = (props: GridCellProps) => {
    const openInNewTab = (url: any) => {
      window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (
      <td>
        {draftKey !== undefined ?
          <button onClick={() => editPosition(props.dataItem.jobId)} className="applyButton"> View</button> :
          <button onClick={(e: any) => {
            localStorage.setItem('PositionsJobId', props.dataItem.jobId);
            localStorage.setItem('PositionsPositionName', props.dataItem.positionName);
            localStorage.setItem('PositionsCompanyName', props.dataItem.company);
            openInNewTab(`${window.location.origin}/position-details`)
            // navigate('../position-details', { state: { jobId: props.dataItem.jobId, positionName: props.dataItem.positionName, companyName: props.dataItem.company, jobStatus: props.dataItem.job_status } })
          }
          }
            className="applyButton">
            View
          </button>
        }
      </td>
    );
  };

  const editPosition = (jobId: any) => {
    getPositionsDetails(jobId).then(
      (response: any) => {
        if (response && response.status === "1") {
          navigate('/createPositions', { state: { data: response.data[0], jobId: response.data[0].job_id, jobStatus: response.data[0].job_status } })
        }
      }
    )
  }

  const rowClick = (e: any) => {
    props.rowClick(e);
  };

  const getTableValues = () => {
    props.getTables()
  }
  //vishnu
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const redirection = (jobId: string, positionName: string, companyName: string) => {
    localStorage.setItem('PositionsJobId', jobId);
    localStorage.setItem('PositionsPositionName', positionName);
    localStorage.setItem('PositionsCompanyName', companyName);
    openInNewTab(`${window.location.origin}/position-details`)
    // navigate('../position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName } })
  }

  const companyCell = (props: GridCellProps) => {
  
    const companySettingsRedirection = (data: any) => {
      data.companyType = 1;
      localStorage.setItem('CompanySettings', JSON.stringify(data))
      openInNewTab(`${window.location.origin}/companysettings`)

  }

    return (
      <td onClick={() => companySettingsRedirection(props.dataItem)}>
        {props.dataItem.company}
      </td>
    )
}

  return (
    <Grid
      data={props.state.items}
      onPageChange={props.pageChange}
      total={props.state.total}
      skip={props.state.skip}
      pageable={props.state.pageable}
      pageSize={props.state.pageSize}
      onRowClick={(e) => rowClick(e)}
      sortable={true}
      sort={sort}
      onSortChange={(e) => {
        setSort(e.sort);
        props.setSort(e.sort);
        props.applySort(e.sort);
      }}
    >
      <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
      <Column field="priority" title="Priority" cell={(props: GridCellProps) => DropDown(props, () => getTableValues())} width="80px" />
      <Column field="positionName" title="Job Title" width="140px" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string, positionName: string, companyName: string) => redirection(candidateLoginId, positionName, companyName))} />
      <Column field="company" title="Company" cell={companyCell}/>
      <Column field="activePosition" title="Active Positions" cell={positionCountCell} />
      <Column field="jobType" title="JobType" />
      <Column field="experienceLevel" title="Experience" cell={experienceCell} />
      <Column field="Skills" title="Skills" cell={skillsCell} />
      <Column field="OpenFor" title="OpenFor" cell={openForCell} />
      <Column field="allocated_to" title="AllocatedTo" cell={(props: GridCellProps) => AllocatedDropdown(props, () => getTableValues())} />
      <Column field="profiles" title="Profiles" cell={profileCell} />
      <Column cell={viewButton} width="70px" />
    </Grid>
  );
};

export default PositionTable;

const skillsCell = (props: GridCellProps) => {

  let length = props.dataItem.skills && props.dataItem.skills.length;

  return (
    <td >
      <div className="skillsWrap">
        {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
          return ((item) + (key < length - 1 ? ' , ' : ''))
        })}
      </div>
    </td>
  );
};

const positionCountCell = (props: GridCellProps) => {
  return <td>{props.dataItem.positionCount ? props.dataItem.positionCount : props.dataItem.positionCount}</td>;
};

const experienceCell = (props: GridCellProps) => {
  return <td>{props.dataItem.experienceLevel ? props.dataItem.experienceLevel.min + " - " + props.dataItem.experienceLevel.max + " Years" : 'Not Mentioned'}</td>
};

const profileCell = (props: GridCellProps) => {

  if (props.dataItem.profiles && props.dataItem.profiles.length > 1) {
    return <td>
      <div className="positionStstus">
        <PopOver title="Multiple Position" position="rightBottom">
          {props.dataItem.profiles.map((item: string, key: number) => {
            return (
              <div key={key} className="positionList">
                <span className="status warning" />
                {item}
              </div>
            )
          })
          }
        </PopOver>
      </div>
      {/* <div className="multiPositions">
        <div className="multiPositionItem">SH<strong>12</strong></div>
        <div className="multiPositionItem">Shortlisted<strong>08</strong></div>
        <div className="multiPositionItem">RA<strong>03</strong></div>
      </div> */}
    </td>
  }
  else {
    return <td>{props.dataItem.profiles}</td>
  }
}

const openForCell = (props: GridCellProps) => {

  return <td>{timeSince(props.dataItem.createdDate)}</td>
};

const nameCell = (props: GridCellProps, redirection: any) => {

  return (
    <td>
      <div className="userInfo" onClick={() => redirection(props.dataItem.jobId, props.dataItem.positionName, props.dataItem.company)}>
        {props.dataItem.positionName}
      </div>
    </td>
  )
}
